import { render, staticRenderFns } from "./UserMessage.vue?vue&type=template&id=0b4aaa2f&scoped=true&"
import script from "./UserMessage.vue?vue&type=script&lang=js&"
export * from "./UserMessage.vue?vue&type=script&lang=js&"
import style0 from "./UserMessage.vue?vue&type=style&index=0&id=0b4aaa2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4aaa2f",
  null
  
)

export default component.exports